var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h512v512h-512z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.477 512a258.841 258.841 0 0 1 -51.689-5.2 255.327 255.327 0 0 1 -91.71-38.52 256.81 256.81 0 0 1 -92.923-112.635 254.363 254.363 0 0 1 -14.944-48.053 258.024 258.024 0 0 1 0-103.186 254.344 254.344 0 0 1 38.589-91.539 256.784 256.784 0 0 1 442.367 29.1 254.014 254.014 0 0 1 25.833 91.771h-114.488a142.318 142.318 0 0 0 -30.744-67.638 143.485 143.485 0 0 0 -37.319-31.987 142.876 142.876 0 1 0 20.751 230.659 143.4 143.4 0 0 0 31.272-38.531 141.808 141.808 0 0 0 16.333-47.982h114.195a254.593 254.593 0 0 1 -50.447 131.508 257 257 0 0 1 -110.153 84.125 255.62 255.62 0 0 1 -45.9 13.433 259.066 259.066 0 0 1 -49.023 4.675z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.141 97.035c-17.012-58.883-57.859-89.158-106.715-89.158s-98.604 36.762-109.171 89.158z",
    fill: "#dbc772",
    transform: "translate(147.607 135.055)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoText);
export default __webpack_public_path__ + "static/media/logo-no-text.a92813bee11c7bd3b48ecb7485b97bdb.svg";
export { ForwardRef as ReactComponent };